module.exports = __webpack_public_path__ + "static/media/done.c39ca479.svg";